import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/EBooks/Banner';
import Header from '../Components/Shared/Header/Header';
import Cards from '../Components/Pages/EBooks/Cards';
import Load from '../Components/Pages/EBooks/Load';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function EBooks(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Load />
        <Start />
        <Footer />
        </>
    )
};
export default EBooks ;